import type { IVehicle, LeaseAnnualMiles } from '@makemydeal/dr-platform-types';
import { CashOptions } from '@makemydeal/dr-platform-types';
import { vehicleUtils } from '@makemydeal/dr-platform-shared';
import type { AnyAction } from 'redux';
import * as types from '../types/actionTypes';
import { formattedInventoryDate } from '../utils/shopperUtils';
import { initialState } from './initialState';

export function vehicle(state: IVehicle = initialState.vehicle, action: AnyAction) {
    switch (action.type) {
        case types.INIT_INVALID_OFFER:
        case types.INIT_OFFER:
            return {
                ...state,
                ...action.payload.vehicle,
                retailPrice: action.payload?.vehicle?.retailPrice || action.payload?.vehicle?.listedPrice,
                initialRetailPrice: action.payload?.vehicle?.retailPrice
            };
        case types.SYNC_MESSAGE:
            return {
                ...state,
                ...action.message.offer.vehicle
            };
        case types.VEHICLE_SUCCESS:
            return {
                ...state,
                exteriorColor: action.payload?.exteriorColor,
                fuel: action.payload?.fuel,
                bodyStyle: action.payload?.bodyStyle,
                inventoryDate: formattedInventoryDate(action.payload?.inventoryDate)
            };

        case types.VEHICLE_RETAIL_PRICE_CHANGED:
            return {
                ...state,
                retailPrice: action.payload.retailPrice
            };
        case types.SWITCH_VEHICLE:
            return { ...action.payload };
        case types.UPDATED_VEHICLE_INFO_DETAILS:
            return action.payload?.vehicle !== undefined ? { ...state, ...action.payload.vehicle } : state;
        case types.FETCH_CVI_VEHICLE_SUCCESS:
            if (action.payload?.length === 1) {
                return {
                    ...state,
                    invoiceAmount: state.invoiceAmount ?? action.payload[0].invoicePrice,
                    chromeStyleId: state.chromeStyleId ?? vehicleUtils.parseChromeStyleId(action.payload[0].chromeId)
                };
            }
            return state;
        case types.APPLY_RECOMMENDED_VEHICLE_PAYMENT_DETAILS: {
            const { vehicle } = action.payload;
            return {
                ...state,
                ...vehicle,
                mileage: vehicle.odometer,
                initialRetailPrice: vehicle.retailPrice
            };
        }
        default:
            return state;
    }
}

export function cashApplyMethod(state: string | undefined = initialState.cashApplyMethod, action: AnyAction) {
    switch (action.type) {
        case types.UPDATE_IS_TARGET_OUT_OF_POCKET: {
            const isTargetOutOfPocket = action.payload || false;
            const cashApplyMethod = isTargetOutOfPocket ? CashOptions.AddCashOffsetToPrice : '';
            return cashApplyMethod;
        }
        case types.INIT_OFFER:
            return action.payload.cashApplyMethod ?? '';
        default:
            return state;
    }
}

export function isTargetOutOfPocket(state: boolean | undefined = initialState.isTargetOutOfPocket, action: AnyAction) {
    switch (action.type) {
        case types.INIT_OFFER:
            return action.payload.isTargetOutOfPocket ?? false;
        default:
            return state;
    }
}

export function leaseAnnualMiles(state: LeaseAnnualMiles | undefined = initialState.leaseAnnualMiles, action: AnyAction) {
    switch (action.type) {
        case types.INIT_OFFER:
            return { ...state, ...action.payload.leaseAnnualMiles };
        case types.SYNC_MESSAGE:
            return { ...state, ...action.message.offer.leaseAnnualMiles };
        default:
            return state;
    }
}

export const leaseMileage = (state: number | undefined = initialState.leaseMileage, action: AnyAction) => {
    switch (action.type) {
        case types.INIT_SUCCESS: {
            return action.payload.offer.leaseTerms?.mileage || 0;
        }
        default: {
            return state;
        }
    }
};
